import TradeOperationsTable from './TradeOperationsTable';

export default TradeOperationsTable;
